import { MatPaginator } from '@angular/material/paginator';


import { Component, ViewChild, inject, ViewEncapsulation } from '@angular/core';
import { VendaArlaService } from '../venda-arla.service';
import {
  BuscaPostosDTO,
  IBuscaAtualizaPostosDTO,
} from '../model/I-busca-postos-dto';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';

@Component({
  selector: 'app-gerenciar-postos',
  templateUrl: './gerenciar-postos.component.html',
  styleUrls: ['./gerenciar-postos.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GerenciarPostosComponent {
  private arlaService = inject(VendaArlaService);
  private snackBarService = inject(SnackBarService);


  dataSource = new MatTableDataSource<BuscaPostosDTO>();
  colsAndRows: string[] = [
    'posto',
    'nome_posto',
    'cidade',
    'estado',
    'endereco',
    'vendaArlaAutorizado',
  ];
  loading: boolean = false;
  postos: Array<BuscaPostosDTO> = [];
  postosFiltrados: Array<BuscaPostosDTO> = [];
  estados: Array<string> = [];
  cidades: Array<string> = [];


  @ViewChild(MatPaginator)
  paginator?: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor() {
    this.dataSource = new MatTableDataSource<BuscaPostosDTO>();
    this.loading = true;

    this.arlaService.buscarPostos().subscribe((data) => {
      this.dataSource.data = data.retorno;
      this.loading = false;
      
      this.postos = data.retorno;
      if (this.postos != null && this.postos.length > 0) {
        this.estados = this.retornaArrayComValoresUnicos(
          this.postos.map((posto) => posto.estado)
        );
        this.cidades = this.retornaArrayComValoresUnicos(
          this.postos.map((posto) => posto.cidade)
        );
      }else{
        this.mostrarMensagens(data.mensagens[0] || 'Erro no retorno da aplicação, favor contatar o responsável.', 'error');
      }

    });
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }
  
  liberarArlaEmTodos(indVendaArla: boolean) {

    const confirm = window.confirm(`Deseja realmente ${indVendaArla ? 'liberar' : 'bloquear'} a venda de Arla em ${ this.dataSource.data.length} postos?`);

    var listaIdPostos: Array<IBuscaAtualizaPostosDTO> = [];  
    // pegar uma lista de ids de postos e enviar para o backend
    this.dataSource.data.forEach((posto) => {
      listaIdPostos.push({codigoPosto: posto.codigoPosto});
    });

    if(!confirm || listaIdPostos.length == 0)
      return;



    this.loading = true;
    this.arlaService.atualizarPosto(indVendaArla,listaIdPostos).subscribe((response) => {

      if(response.sucesso){
        this.dataSource.data.forEach((posto) => {
          posto.vendaArlaPermitida = indVendaArla;
        });

        indVendaArla ? this.mostrarMensagens( `Venda de Arla nos postos liberada com sucesso`) :
        this.mostrarMensagens( `Venda de Arla nos postos bloqueada com sucesso`);
      }else
        this.mostrarMensagens(response.mensagens[0] || 'Erro no retorno da aplicação, favor contatar o responsável.', 'error');

        this.loading = false;
    });
   
  }

  mostrarMensagens(msg: string, tipo: string = 'success') {
    this.snackBarService.flashMessage(msg, [ `snackbar-${tipo}`], 'Fechar', 5);
  }

  mostrarTodos() {
    this.postosFiltrados = this.postos;
    this.organizarDados();
  }

  organizarDados() {
    this.estados = [];
    this.cidades = [];

    this.postosFiltrados.forEach((posto) => {
      if (!this.estados.includes(posto.estado.trim().toLocaleUpperCase()))
        this.estados.push(posto.estado.trim().toLocaleUpperCase());

      if (!this.cidades.includes(posto.cidade.trim().toLocaleUpperCase()))
        this.cidades.push(posto.cidade.trim().toLocaleUpperCase());
    });

    this.estados.sort();
    this.cidades.sort();
  }

  filtrarPorEstado(estado: string) {
    estado == 'todos'
      ? (this.dataSource.data = this.postos)
      : (this.dataSource.data = this.postos.filter((posto) => {
          return posto.estado.trim().toUpperCase() === estado.toUpperCase();
        }));

    this.cidades = this.retornaArrayComValoresUnicos(
      this.dataSource.data.map((posto) => posto.cidade)
    );
    this.estados = this.retornaArrayComValoresUnicos(
      this.dataSource.data.map((posto) => posto.estado)
    );
  }

  filtrarPorCidade(cidade: string) {
    cidade == 'todos'
      ? (this.dataSource.data = this.postos)
      : (this.dataSource.data = this.postos.filter((posto) => {
          return posto.cidade.trim().toUpperCase() === cidade.toUpperCase();
        }));

    this.estados = this.retornaArrayComValoresUnicos(
      this.dataSource.data.map((posto) => posto.estado)
    );
    this.cidades = this.retornaArrayComValoresUnicos(
      this.dataSource.data.map((posto) => posto.cidade)
    );
  }

  buscaTokenInputPosto(v: string) {
    this.dataSource.data = this.postos.filter((posto) => {
      return (
        posto.nomePosto.includes(v.trim().toUpperCase()) ||
        posto.codigoPosto == Number(v)
      );
    });
  }

  gerenciarVendaArla(ev: MatCheckboxChange, posto: BuscaPostosDTO) {
    var indVendaArla = ev.checked;

    this.arlaService.atualizarPosto(indVendaArla, [{'codigoPosto': posto.codigoPosto}]).subscribe((response) => {
      if(response.sucesso){
        ev.checked ? this.mostrarMensagens( `Venda de Arla no posto: ${posto.nomePosto} liberada com sucesso`) :
        this.mostrarMensagens( `Venda de Arla no posto: ${posto.nomePosto} bloqueada com sucesso`);
      }else{
        this.mostrarMensagens(response.mensagens[0] || 'Erro no retorno da aplicação, favor contatar o responsável.', 'error');
        posto.vendaArlaPermitida = !indVendaArla;
      }
    
    });
  }

  retornaArrayComValoresUnicos(valores: Array<string>): Array<string> {
    return Array.from(new Set(valores)).sort();
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();

    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
    } else {
      this.dataSource.data = data.sort((a, b) => {
        const aValue = (a as any)[sort.active];
        const bValue = (b as any)[sort.active];
        return (aValue < bValue ? -1 : 1) * (sort.direction === 'asc' ? 1 : -1);
      });
    }
  }

}
